import React from 'react';
import PropTypes from 'prop-types';

import ConditionsMarkdown from '../ConditionsMarkdown';
import Modal from '../Modal';
import QantasPackageBookingConditionsContent from './bookingConditionsContent.md';

const BookingConditionsModal = ({ close }) => (
  <Modal onClose={() => close()}>
    <Modal.Header>Terms and Conditions</Modal.Header>
    <Modal.Body>
      <ConditionsMarkdown markdown={QantasPackageBookingConditionsContent} />
    </Modal.Body>
  </Modal>
);

BookingConditionsModal.propTypes = {
  close: PropTypes.func.isRequired,
};

export default BookingConditionsModal;
